import { TagTypes } from '../../../Api/Types/tagTypes';
import { OfferOptionsMapping } from '../Types/offerOptionsMappingsTypes';
import { offerOptionsMappingsApi } from './offerOptionsMappingsApi';

const extendedOfferOptionsMappingsApi = offerOptionsMappingsApi.injectEndpoints({
  endpoints: (builder) => ({
    getByOfferId: builder.query<OfferOptionsMapping[], number>({
      query: (offerId) => `offer-options-mapping/offer/${offerId}`,
      providesTags: (result, error, offerId) => {
        if (result) {
          return [
            { type: TagTypes.OfferOptionsMapping as const, id: offerId },
            ...result.map(({ id }) => ({ type: TagTypes.OfferOptionsMapping as const, id })),
          ];
        }
        return [{ type: TagTypes.OfferOptionsMapping as const, id: offerId }];
      },
    }),
  }),
  overrideExisting: false,
});
export const { useGetByOfferIdQuery } = extendedOfferOptionsMappingsApi;
